import {$, ID, Resource, success} from 'simpli-web-sdk'
import {
  ResponseSerialize,
} from 'simpli-web-sdk'
import Responsavel from '@/model/resource/Responsavel'

export default class ResponsavelPermissao extends Resource {
  readonly $name: string = 'ResponsavelPermissao'

  readonly $endpoint: string = '/user/config-permissao'

  get $id() {
    return this.idResponsavelFk
  }
  set $id(val: ID) {
    this.idResponsavelFk = val
  }

  idResponsavelFk: ID = 0

  permitirRaioAuditoriaCheckin: boolean = false
  raioAuditoriaCheckinMetros: number | null = null

  permitirRaioAuditoriaEntrega: boolean = false
  raioAuditoriaEntregaMetros: number | null = null

  async persistResponsavelPermissao(spinner = 'persistResponsavelPermissao') {
    const fetch = async () => {
      await this.POST(`/user/config-permissao/responsavel-permissao`, this)
    }
    await $.await.run(fetch, spinner)
    success('system.success.persist')
  }

  async getResponsavelPermissao(id: number | string, spinner = 'getRaioAuditoria') {
    const fetch = async () => await this.GET(`/user/config-permissao/responsavel-permissao/${id}`)
    return await $.await.run(fetch, spinner)
  }
}
